import { useAuthStore } from "#imports";

export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.server) {
        return;
    }

    const authStore = useAuthStore();
    const auth = useNuxtApp().$auth;
    await authStore.awaitAuthReady();
    const user = authStore.user || auth.currentUser;

    if (!user) {
        const redirect = encodeURIComponent(to.fullPath || '/');
        return navigateTo(`/auth/login?redirect=${redirect}`);
    }

    if (to.path === '/onboarding' && !user.emailVerified) {
        const redirect = encodeURIComponent(to.fullPath || '/onboarding');
        return navigateTo(`/auth/verify-email?redirect=${redirect}`);
    }
});
